<template>
  <div class="form login" :class="{ mobile_flag: mobile_flag }">
    <!-- 手机号 微信扫码绑定手机-->
    <el-form>
      <div v-if="showPass">
        <h1
          class="title"
          style="margin-bottom: 50px; margin-top: 40px; font-size: 30px"
        >
          绑定手机号
        </h1>
        <el-row style="margin-bottom: 15px">
          <el-col>
            <el-form-item>
              <el-input
                style="display: block; width: 237px; margin: 0px auto"
                placeholder="请输入您的手机号"
                @blur="phonea"
                v-model="shuru.phone"
              ></el-input>
              <div class="el-form-item__error" style="text-indent: 10px">
                {{ cuowuspan.phone }}
              </div>
            </el-form-item>
          </el-col>
        </el-row>
        <!-- 验证码 -->
        <el-row>
          <el-col>
            <el-form-item style="text-align: right">
              <el-button
                type="warning"
                style="min-width: 110px; padding: 10px"
                round
                :disabled="disabled || shuru.phone.length != 11"
                @click="send"
                :class="
                  shuru.phone.length != 11
                    ? 'yzm'
                    : sends != '获取验证码'
                    ? 'yzm'
                    : 'Obtain'
                "
                >{{ sends }}</el-button
              >
            </el-form-item>
          </el-col>
          <!-- <el-col :span="1">
            <el-form-item></el-form-item>
          </el-col>-->
          <el-col>
            <el-form-item>
              <el-input
                style="display: block; width: 237px; margin: 0px auto"
                placeholder="输入验证码"
                @blur="Verificationa"
                v-model="shuru.Verification"
              ></el-input>
              <div class="el-form-item__error" style="text-indent: 10px">
                {{ cuowuspan.Verification }}
              </div>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col>
            <el-form-item>
              <el-button
                class="customBtn"
                type="warning"
                round
                @click="nextStep"
                :class="
                  this.shuru.Verification !== ''
                    ? 'elbutton_pt'
                    : 'elbutton_pt_er'
                "
                :style="{
                  color: this.shuru.Verification !== '' ? 'black' : '',
                }"
                >下一步</el-button
              >
            </el-form-item>
          </el-col>
        </el-row>
      </div>
      <!-- 密码 -->
      <template v-if="!showPass && !phoneRegistered" style="position: relative">
        <div class="backpage_da">
          <p class="backpage" @click="back_Da">
            <i class="el-icon-back"></i>
          </p>
        </div>
        <h1 class="title" style="margin-bottom: 25px; margin-top: 20px">
          请设置您的密码
        </h1>
        <el-row>
          <el-col>
            <el-form-item style="margin-bottom: 16px">
              <el-input
                class="custom-input"
                placeholder="请输入您的密码"
                @blur="passa"
                v-model="shuru.pass"
                show-password
                maxlength="25"
                minlength="8"
              ></el-input>
              <div class="el-form-item__error" style="text-indent: 10px">
                {{ cuowuspan.pass }}
              </div>
            </el-form-item>
            <ul class="m-mim custom-input">
              <li>
                <span :class="{ curr: /\d/.test(shuru.pass) }">●</span
                >密码中包含数字
              </li>
              <li>
                <span :class="{ curr: /[a-zA-Z]/g.test(shuru.pass) }">●</span
                >密码中包含字母
              </li>
              <li>
                <span
                  :class="{
                    curr: shuru.pass.length >= 8 && shuru.pass.length <= 25,
                  }"
                  >●</span
                >8-25位密码且没有特殊字符
              </li>
            </ul>
          </el-col>
        </el-row>
        <el-row>
          <el-col>
            <el-form-item style="margin-bottom: 18px">
              <el-input
                class="custom-input"
                placeholder="请再次确认您的密码"
                @blur="passworda"
                v-model="shuru.password"
                show-password
                maxlength="25"
                minlength="8"
              ></el-input>
              <div class="el-form-item__error" style="text-indent: 10px">
                {{ cuowuspan.password }}
              </div>
            </el-form-item>
          </el-col>
        </el-row>
        <el-button
          :class="[
            shuru.password == shuru.pass &&
            shuru.password != '' &&
            shuru.pass != '' &&
            /^(?![0-9]+$)(?![a-zA-Z]+$)[0-9A-Za-z]{8,25}$/.test(shuru.pass) &&
            /^(?![0-9]+$)(?![a-zA-Z]+$)[0-9A-Za-z]{8,25}$/.test(shuru.password)
              ? 'nextY'
              : 'nextY_er',
          ]"
          @click="ConfirmPassword"
          >下一步</el-button
        >
        <div class="Tips" v-show="Tips">
          <p class="backpage">
            <i class="el-icon-back" @click="backPassword"></i>
            <span class="titile_prompt">温馨提示</span>
          </p>

          <div class="TitlePromptContent">
            <section class="container">
              <dl>
                <dt>
                  <font>●</font>
                  新人注册成功则免费赠送
                  <strong>2</strong>海星点
                </dt>
                <dt class="one">
                  <font>●</font>
                  线路情况：3070线路/3090线路/4090线路 支持rtx光追和dlss2.0。
                </dt>
                <dt class="one">
                  <font>●</font> 计费规则：<strong>2海星点/小时</strong>。
                </dt>
                <dt class="one">
                  <font>●</font> 用户可申请实名认证,
                  <strong>实名认证成功可获得6海星点赠点奖励</strong>
                  (前往官网或下载海星云安卓版进行实名认证，iOS版敬请期待)。
                </dt>

                <dt class="one">
                  <font>●</font>
                  排队机制：智能排队，VIP等级高的优先排队，VIP等级说明详见官网个人中心或手机客户端。
                </dt>
                <dt class="one">
                  <font>●</font>
                  海星云平台禁止使用外挂、进行比特币等数字货币挖矿等违约、违规、违法、违反公序良俗、侵犯屯云科技或他人权益的行为，一经发现，即刻封号，敬请悉知。
                </dt>
              </dl>
            </section>
          </div>
          <div class="footer_btn">
            <button class="next_button" @click.prevent="q_FinalRequest">
              下一步
            </button>
          </div>
        </div>
        <div class="FinalRequest" v-show="FinalRequest">
          <p class="backpage">
            <i class="el-icon-back" @click="back_backPassword"></i>
            <i
              class="el-dialog__close el-icon el-icon-close"
              @click="fhpas"
            ></i>
          </p>
          <h4 class="titile title1">填写邀请码</h4>
          <el-row>
            <el-col>
              <el-form-item class="yqm-el-form-item">
                <el-input
                  class="custom-input"
                  placeholder="填写八位数邀请码(选填)"
                  @blur="invitationa"
                  v-model="shuru.invitation"
                  :disabled="yaoqm"
                ></el-input>
                <div class="el-form-item__error">
                  {{ cuowuspan.invitation }}
                </div>
              </el-form-item>
            </el-col>
          </el-row>

          <el-button
            class="customBtn wancheng"
            type="warning"
            round
            @click="Register1"
            >完成</el-button
          >
          <el-button
            @click="JudgmentInCoJump"
            class="customBtn wancheng wancheng1"
            type="warning"
            >完成（跳过邀请码）</el-button
          >
          <div class="ITC_footer">
            <div class="ITCF_img">
              <img src="../../static/bp.png" alt />
            </div>
            <span>
              受
              <em>vip0</em>及其以上用户邀请的新人
            </span>
            <span>
              注册首充
              <em>50</em>元,可获得 <em>25</em>点奖励
            </span>
            <span>
              受
              <em>vip3</em>及其以上用户邀请的新人
            </span>
            <span>
              注册首冲
              <em>200</em>元,可获得 <em>100</em>点奖励
            </span>
            <div class="jsq">(本活动最终解释权归海星云官方所有)</div>
          </div>
        </div>
      </template>
    </el-form>
  </div>
</template>

<script>
import adaption from '@/mixi/adaption'
let Alltxid = '2075896218'
export default {
  mixins: [adaption],
  data () {
    return {
      // 滑块参数
      nc_token: '',
      csessionid: '',
      sig: '',
      access_token: '',
      open_id: '',
      // 发送验证按按钮
      sendstime: 60,
      disabled: false,
      sends: '获取验证码',
      checked: false,
      shifou: false,
      showPass: true,
      password_show: false,
      img: '',
      Return: './../../static/images/icon/Return.png',
      why: false,
      zhucexieyi: false,
      shuru: {
        phone: '',
        Verification: '',
        pass: '',
        password: '',
        email: '',
        invitation: '' // 邀请码 选填
      },
      // 错误的提示信息
      cuowuspan: {
        phone: '',
        Verification: '',
        pass: '',
        password: '',
        email: '',
        invitation: ''
      },
      // 标识符
      phone: true,
      Verification: true,
      pass: true,
      sceneaa: '',
      yzmIcon: null,
      phone_exist: false,
      phoneRegistered: false, // 默认手机号未注册
      inviteCode: true, // 邀请码默认校验通过
      // 人机验证返回数据
      bizState: null,
      Alltxid,
      ticket: '',
      randstr: '',
      // 人机验证 得到的值
      randstr: '',
      ticket: '',
      // 温馨提示显示隐藏
      Tips: false,

      // 最终注册请求显示隐藏
      FinalRequest: false
    }
  },
  methods: {
    // 判断注册绑定还是绑定
    nextStep () {
      if (!this.phoneRegistered && this.cuowuspan.phone === '' && this.yzmIcon === 'el-icon-success' && this.Verification == false && this.cuowuspan.Verification === '') {
        // 新用户绑定微信
        this.http.checkPhone(this.shuru.phone, this.shuru.Verification, 'register').then(res => {
          if (res.status === 200 && res.data.code === 200) {
            this.showPass = false
          } else {
            this.$message.error(res.data.message)
            console.log(res.data.message)
          }
        })
      }
      if (this.phoneRegistered && this.yzmIcon === 'el-icon-success' && this.cuowuspan.Verification === '') {
        // 老用户绑定微信
        this.http.checkPhone(this.shuru.phone, this.shuru.Verification, 'register').then(res => {
          console.log(res, '扫码后判断验证码是否正确')
          if (res.status === 200 && res.data.code === 200) {
            this.Register()
          } else {
            this.$message.error(res.data.message)
          }
        })
      }
    },
    // 新老用户绑定微信
    Register () {
      // 邀请码
      let _yaoqin = this.shuru.invitation
      if (_yaoqin) {
        this.Verificationa()
        _yaoqin = this.shuru.invitation.toUpperCase()
        // if (_yaoqin.length > 8) {
        //   _yaoqin = _yaoqin.substring(0, 4) + _yaoqin.substring(5, 9)
        // }
      }
      // console.log(this.shuru.phone, '手机号')
      // console.log(this.shuru.Verification, '验证码')
      // console.log(typeof this.shuru.pass, '密码')
      // console.log(this.access_token, '小token')
      // console.log(this.open_id, 'open_id')
      // console.log(typeof _yaoqin, '邀请码')
      this.http
        .Bindwx(
          this.shuru.phone,
          this.shuru.Verification,
          '',
          this.access_token,
          this.open_id,
          this.shuru.invitation
        )
        .then(res => {
          console.log(res, '绑定请求返回值')
          if (res.data.code == 200) {
            this.$message({
              message: '恭喜您！绑定成功',
              type: 'success'
            })
            this.$cookieStore.setCookie(
              'user_sess',
              res.data.data.token,
              2590000
            )
            if (!this.phoneRegistered) {
              this.$emit('global:openLoginSucce')
            } else {
              this.$router.push({
                path: './Center',
                query: {value: 'nice'}
              })
            }
          } else if (res.data.code == 400) {
            this.$message.error(res.data.message)
          }
        })
    },
    send () {
      this.nc_token = this.$cookieStore.getCookie('nc_token')
      this.csessionid = this.$cookieStore.getCookie('csessionid')
      this.sig = this.$cookieStore.getCookie('sig')
      if (this.shuru.phone == '') {
        this.cuowuspan.phone = '请填写手机号'
        this.phone = true
        return false
      } else {
        this.http.yzpho(this.shuru.phone).then(res => {
          console.log(res, '发送验证码判断是否注册')
          if (res.data.code == 200) {
            if (res.data.message == 'false') {
              // this.cuowuspan.phone = '您未注册，请先注册！'
              this.initTencentCaptcha().then(res => {
                // console.log(res)
                this.ticket = res.ticket
                this.randstr = res.randstr
                if (res.ret === 0) {
                  this.http.send(this.shuru.phone, this.nc_token, this.csessionid, this.sig, 'register')
                    .then(res => {
                      // console.log(res)
                      if (res.data.code == 200 && res.data.message == 'ok') {
                        this.Changebutton = 2
                        this.$message({
                          message: '验证码已发送到您的手机，请注意查看',
                          type: 'success'
                        })
                        let that = this
                        let resend = setInterval(function () {
                          that.sendstime--
                          if (that.sendstime > 0) {
                            that.sends = `已发送(${that.sendstime}s)`
                            // that.sends = that.sendstime + 's后重新获取'
                            that.disabled = true
                          } else {
                            clearInterval(resend)
                            that.sends = '获取验证码'
                            that.sendstime = 60
                            that.disabled = false
                          }
                        }, 1000)
                      } else {
                        this.$message('获取验证码太频繁了')
                        let that = this
                        let resend = setInterval(function () {
                          that.sendstime--
                          if (that.sendstime > 0) {
                            that.sends = `已发送(${that.sendstime}s)`
                            that.disabled = true
                          } else {
                            clearInterval(resend)
                            that.sends = '获取验证码'
                            that.sendstime = 60
                            that.disabled = false
                          }
                        }, 1000)
                      }
                    })
                }
              })
              this.phone = true
            } else if (res.data.message == 'true') {
              this.http
                .send(this.shuru.phone, this.nc_token, this.csessionid, this.sig, 'register')
                .then(res => {
                  console.log(res, '老用户直接发送验证码')
                  if (res.data.code == 200) {
                    if (res.data.message == 'ok') {
                      this.Changebutton = 1
                      this.$message({
                        message: '验证码已发送到您的手机，请注意查看',
                        type: 'success'
                      })
                      var that = this
                      var resend = setInterval(function () {
                        that.sendstime--
                        if (that.sendstime > 0) {
                          that.sends = that.sendstime + 's后重新获取'
                          that.disabled = true
                        } else {
                          clearInterval(resend)
                          that.sends = '获取验证码'
                          that.sendstime = 60
                          that.disabled = false
                        }
                      }, 1000)
                    }
                  } else if (res.data.code == 400) {
                    if (res.data.message == 'failed,unable to get data') {
                      this.$message.error('不能获取到数据')
                    } else if (res.data.message == 'failed,user phone invalid') {
                      this.$message.error('手机号无效')
                    } else if (
                      res.data.message == 'failed,afs authenticate invalid'
                    ) {
                      this.$message.error('滑块验证失败')
                    }
                  } else if (res.data.code == 500) {
                    if (res.data.message == 'failed,please retry!') {
                      this.$message.error('验证码发送过于频繁，请稍后再试。，请重试！')
                    }
                  } else if (res.data.code == 403) {
                    this.$message.error('验证码发送过于频繁，请稍后再重新尝试!')
                  }
                })
            }
          } else if (res.data.code == 500) {
            this.$notify({
              title: '请联系管理员咨询',
              type: 'warning'
            })
          }
        })
      }
    },
    // 人机验证
    initTencentCaptcha (cb) {
      const _this = this
      return new Promise((resolve, reject) => {
        const TC = new TencentCaptcha(
          Alltxid,
          function (res) {
            resolve(res)
            cb && cb(res)
            if (res.ret === 0) {
              _this.ticket = res.ticket
              _this.randstr = res.randstr
              _this.bizState = res.bizState
              _this.Alltxid = res.appid
            } else if (res.ret === 2) {
              console.logh('用户关闭了')
            }
          },
          {bizState: '自定义透传参数'}
        )
        TC.show()
      })
    },
    Verificationa () {
      if (this.shuru.Verification == '') {
        this.cuowuspan.Verification = '请输入验证码'
        this.Verification = true
        return false
      } else if (this.shuru.Verification) {
        var reg = /^\d{6}$/
        if (reg.test(this.shuru.Verification)) {
          this.Verification = false
          this.cuowuspan.Verification = ''
        } else {
          this.Verification = true
          this.cuowuspan.Verification = '验证码格式有误'
          return false
        }
      }
    },
    phonea () {
      if (this.shuru.phone == '') {
        this.phone = true
        this.cuowuspan.phone = '请填写手机号'
        this.yzmIcon = 'el-icon-error'
        return false
      } else if (this.shuru.phone) {
        var reg = /^1[2-9][0-9]\d{8}$/
        if (reg.test(this.shuru.phone)) {
          this.phone = false
          this.cuowuspan.phone = ''
          this.disabled = false
          this.yzmIcon = 'el-icon-success'
        } else {
          this.phone = true
          this.cuowuspan.phone = '手机号格式有误'
          this.yzmIcon = 'el-icon-error'
          return false
        }
        this.http.yzpho(this.shuru.phone).then(res => {
          if (res.data.code == 200) {
            if (res.data.message == 'true') {
              // 已经注册
              this.phoneRegistered = true
            } else {
              // 未注册
              this.phoneRegistered = false
            }
          } else if (res.data.code == 500) {
            this.$notify({
              title: '请联系管理员咨询',
              type: 'warning'
            })
            return false
          }
        })
      }
    },

    // 返回手机页面
    back_Da () {
      this.showPass = true
    },
    // 返回密码页面
    fhpas () {
      this.FinalRequest = false
      this.Tips = false
      this.showPass = true
      this.shuru.pass = ''
      this.shuru.password = ''
      this.cuowuspan.pass = ''
      this.shuru.phone = ''
      this.shuru.Verification = ''
    },
    // 返回温馨提示
    back_backPassword () {
      this.FinalRequest = false
    },
    // 进入最终注册请求页面
    q_FinalRequest () {
      if (this.shuru.pass === this.shuru.password) {
        this.FinalRequest = true
      } else {
        this.$message.error('请返回上一页,仔细检查密码是否符合注册要求!')
      }
      // console.log('乱跳')
    },
    // 返回密码登录页面
    backPassword () {
      if (this.Tips = true) {
        this.Tips = false
      }
    },
    // 扫码后  填写手机号,如果未注册 ，执行注册
    ConfirmPassword () {
      if (
        this.shuru.password == this.shuru.pass &&
            this.shuru.password != '' &&
            this.shuru.pass != '' &&
            /^(?![0-9]+$)(?![a-zA-Z]+$)[0-9A-Za-z]{8,25}$/.test(this.shuru.pass) &&
            /^(?![0-9]+$)(?![a-zA-Z]+$)[0-9A-Za-z]{8,25}$/.test(this.shuru.password)
      ) {
        this.Tips = true
      } else {
        this.$message.error('请仔细检查密码验证码是否正确！')
      }
    },
    // 注册绑定流程,确定输入密码一致
    passworda () {
      if (this.shuru.pass && this.shuru.pass !== this.shuru.password) {
        this.cuowuspan.password = '两次密码输入不一致'
        this.password = true
        return false
      }
      if (this.shuru.password == '') {
        this.cuowuspan.password = '请再次输入密码'
        this.password = true
        return false
      }
      if (this.shuru.password == this.shuru.pass) {
        this.cuowuspan.password = ''
        this.password = false
        this.cuowuspan.pass = ''
        this.pass = false
      }
    },
    // 注册绑定流程,确定输入密码一致
    passa () {
      if (this.shuru.password && this.shuru.password !== this.shuru.pass) {
        this.cuowuspan.pass = '两次密码输入不一致'
        this.pass = true
        return false
      }
      if (this.shuru.pass == '') {
        this.cuowuspan.pass = '请输入密码'
        this.pass = true
        return false
      } else if (this.shuru.pass) {
        if (this.shuru.pass.length >= 8 && this.shuru.pass.length <= 25) {
          this.cuowuspan.pass = ''
          this.pass = false
          this.cuowuspan.password = ''
          this.password = false
        } else {
          this.cuowuspan.pass = '密码格式有误'
          this.pass = true
          return false
        }
      }
    },

    // 注册绑定部分,邀请码
    invitationa () {
      if (this.shuru.invitation.length === 0) {
        this.cuowuspan.invitation = ''
        this.inviteCode = true
      } else {
        let filterStr = this.shuru.invitation.toUpperCase()
        let tep = ''
        // if (filterStr.length === 9) {
        //   tep = filterStr.substring(0, 4) + filterStr.substring(5, 9)
        // } else if (filterStr.length === 8) {
        //   tep = filterStr
        // }
        if (filterStr.length === 8) {
          tep = filterStr
        }
        this.http.yzyaoqingma(tep).then(res => {
          if (res.data.code == 200) {
            if (res.data.message == 'false') {
              this.cuowuspan.invitation = '该邀请码不存在'
              this.inviteCode = false
            } else {
              this.cuowuspan.invitation = ''
              this.inviteCode = true
            }
          }
        })
      }
    },
    // 发送绑定请求
    Register1 () {
      let reg1 = /\d/
      let reg2 = /[a-zA-Z]/g
      let reg3 = /^(?![0-9]+$)(?![a-zA-Z]+$)[0-9A-Za-z]{8,25}$/
      if (!this.shuru.pass) {
        this.cuowuspan.pass = '请输入您的密码'
        return
      }
      if (this.shuru.pass != this.shuru.password) {
        this.cuowuspan.password = '两次密码输入不一致'
        return
      }
      if (this.cuowuspan.invitation) {
        return
      }
      if (!reg1.test(this.shuru.pass) || !reg2.test(this.shuru.pass) || !reg3.test(this.shuru.pass)) {
        this.$message({
          message: '密码格式错误',
          type: 'warning'
        })
        return false
      }
      let that = this
      setTimeout(() => {
        console.log('这里调用 绑定部分,')
        that.Register()
      }, 200)
    },
    // 跳过邀请码
    JudgmentInCoJump () {
      this.http
        .Bindwx(
          this.shuru.phone,
          this.shuru.Verification,
          this.shuru.pass,
          this.access_token,
          this.open_id,
          ''
        )
        .then(res => {
          // console.log(res,"这里是跳过邀请码部分,默认邀请码为 空  ")
          if (res.data.code == 200) {
            this.$message({
              message: '恭喜您！绑定成功',
              type: 'success'
            })
            this.$cookieStore.setCookie(
              'user_sess',
              res.data.data.token,
              2590000
            )
            if (!this.phoneRegistered) {
              this.$emit('global:openLoginSucce')
            } else {
              this.$router.push({
                path: './Center',
                query: {value: 'nice'}
              })
            }
          } else if (res.data.code == 400) {
            this.$message.error(res.data.message)
          }
        })
    }

  },
  created: function () {
    this.access_token = this.$route.query.access_token
    this.open_id = this.$route.query.open_id
  },
  computed: {
    sendBbtn () {
      return /^1[2-9][0-9]\d{8}$/.test(this.shuru.phone)
    }
  },
  beforeDestroy () {
    this.$cookieStore.delCookie('nc_token')
    this.$cookieStore.delCookie('csessionid')
    this.$cookieStore.delCookie('sig')
  }
}
</script>

<style lang="scss" scoped>
.el-form-item__error {
  color: #f56c6c;
  font-size: 12px;
  line-height: 1;
  padding-top: 4px;
  position: absolute;
  top: 100%;
  left: 8px;
}
.el-row {
  text-align: center;
}
.m-mim {
  margin: 0 auto 10px;
  text-align: left;
}
.title {
  font-size: 25px;
  font-family: NotoSansHans-Black, NotoSansHans;
  font-weight: 900;
  color: rgba(255, 255, 255, 1);
}
.mobile_flag {
  .title {
    font-size: 18px;
  }
}

.invacation {
  text-align: left;
  width: 253px;
  line-height: 25px;
  box-sizing: border-box;
  margin: 0px auto;

  p {
    margin-bottom: 0px;
    color: #ffffff;
    font-weight: Regular;

    font {
      font-family: Noto Sans S Chinese Regular;
      color: #ffca00;
      font-size: 13px;
      font-weight: bold;
    }
  }
}
.yzm {
  line-height: 0px;
  color: #ffffff8a;
  height: 26px;
  position: absolute;
  top: 22px;
  right: 24px;
  z-index: 2;
  border-radius: 5px;
}
.Obtain {
  line-height: 0px;
  color: #ffffff8a;
  height: 26px;
  position: absolute;
  top: 22px;
  right: 24px;
  z-index: 2;
  border-radius: 5px;
  padding-right: 15px !important;
  line-height: 0px !important;
  color: black !important;
  // width: 90px;
  height: 26px;
  position: absolute;
  font-size: 14px;
  background-image: linear-gradient(
    270deg,
    rgba(244, 201, 29, 1) 0%,
    rgba(255, 242, 130, 1) 100%
  );
}
.elbutton_pt {
  display: block;
  width: 237px;
  height: 40px;
  margin: 25px auto 0;
  border-radius: 5px;
  background-image: linear-gradient(
    270deg,
    rgba(244, 201, 29, 1) 0%,
    rgba(255, 242, 130, 1) 100%
  );
}
.elbutton_pt_er {
  display: block;
  width: 237px;
  height: 40px;
  margin: 25px auto 0;
  border-radius: 5px;
  background-color: #a6a9af !important;
  border: 1px solid #a6a9af;
  color: #ffffff8a !important;
}
.elbutton_pt_er span {
  color: #ffffff8a !important;
}

.nextY {
  display: block;
  width: 237px;
  height: 40px;
  margin: 25px auto 0;
  border-radius: 5px;
  background-image: linear-gradient(
    270deg,
    rgba(244, 201, 29, 1) 0%,
    rgba(255, 242, 130, 1) 100%
  );
  border: 1px solid rgba(244, 201, 29, 1);
}
.nextY:hover {
  border: 1px solid rgba(244, 201, 29, 1);
  color: black !important;
}
.nextY span:hover {
  color: black !important;
}
.nextY_er {
  display: block;
  width: 237px;
  height: 40px;
  margin: 25px auto 0;
  border-radius: 5px;
  background-color: #a6a9af !important;
  border: 1px solid #a6a9af;
  color: #ffffff8a !important;
}
.nextY_er span {
  color: #ffffff8a !important;
}
.Tips {
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  border-radius: 15px;
  background-color: #252e45;
  padding: 26px 20px 20px 20px;
}
.backpage {
  width: 100%;
  height: 25px;
}
.backpage i {
  display: block;
  // float: left;
  color: white;
  height: 100%;
  text-align: center;
  width: 50px;
  border-radius: 3px;
  cursor: pointer;
  font-size: 18px;
  line-height: 25px;
}
.backpage i:hover {
  background-color: #6767676e;
}
.TitlePromptContent {
  width: 88%;
  height: 75%;
  border-radius: 5px;
  background-color: #222b42;
  margin: 25px auto 10px;
  font-size: 12px;
  color: white;
  overflow-y: auto;
}
.container {
  height: 100%;
  overflow: auto;
  box-sizing: border-box;
  color: rgba(255, 255, 255, 1);
  font-family: NotoSansHans-Regular, NotoSansHans;
  background-color: #243457;
  width: 100%;
  padding: 15px 12px 25px 12px;
}
strong {
  color: #ffcc00;
  font-weight: bold;
  font-size: 14px;
}
.one {
  margin-top: 20px;
}
.titile_prompt {
  display: block;
  text-align: center;
  width: 100%;
  font-weight: 600;
  font-size: 20px;
  color: white;
  margin-top: -24px;
}

.next_button {
  width: 237px;
  display: block;
  height: 40px;
  line-height: 40px;
  text-align: center;
  margin: 0 auto;
  background-color: #8f8f8f;
  color: #ffffff8a;
  border: none;
  border-radius: 6px;
  background: linear-gradient(to right, #fff282, #f4c91d);
  color: black;
  transition-duration: 0.6s;
}

.next_button_son {
  width: 237px;
  display: block;
  height: 40px;
  line-height: 40px;
  text-align: center;
  margin: 0 auto;
  background-color: #8f8f8f;
  color: #ffffff8a;
  border: none;
  border-radius: 6px;
  transition-duration: 0.6s;
}
.FinalRequest {
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  background-color: #222b42;
  border-radius: 15px;
  padding: 26px 20px 20px 20px;
}
.FinalRequest .title1 {
  text-align: center;
  margin-top: -9px !important;
}
.titile {
  text-align: center;
  margin-top: 35px;
}
.backpage i:nth-child(2) {
  float: right;
  width: 32px;
  height: 32px;
  border-radius: 50%;
  line-height: 32px;
  text-align: center;
  padding: 0;
  position: relative;
  margin-top: -27px;
  z-index: 20;
}
.skip {
  display: inline-block;
  float: right;
  width: 56px;
  height: 25px;
  cursor: pointer;
  text-align: center;
  border-radius: 3px;
  position: absolute;
  top: 20px;
  right: 36px;
  color: white !important;
  line-height: 25px;
}
.skip:hover {
  background-color: #6767676e;
}
.ITC_footer {
  width: 100%;
  margin: 5px auto 0;
  height: 205px;
  position: relative;
  line-height: normal;
}
.jsq {
  font-size: 12px;
  width: 230px;
  left: 15px;
  text-align: center;
}
.ITC_footer span {
  display: block;
  color: white;
  font-size: 12px;
  width: 195px;
  margin: 0 auto;
}
.ITC_footer span em {
  font-size: 14px;
  font-weight: 900;
  color: #ffcc00;
  font-style: normal;
}
.ITCF_img {
  width: 100%;
}
.ITCF_img img {
  width: 100%;
  height: 100%;
}
.wancheng1 {
  margin-top: 6px !important;
}
.yqm-el-form-item {
  margin-bottom: 16px !important;
}
.wancheng {
  display: block;
  margin: 0px auto 0;
  width: 237px;
  display: block;
  height: 38px;
  text-align: center;
  background-color: #8f8f8f;
  color: #ffffff8a;
  border: none;
  border-radius: 6px;
  background: -webkit-gradient(
    linear,
    left top,
    right top,
    from(#fff282),
    to(#f4c91d)
  );
  background: linear-gradient(to right, #fff282, #f4c91d);
  color: black;
  -webkit-transition-duration: 0.6s;
  transition-duration: 0.6s;
}
.backpage_da {
  width: 100px;
  height: 35px;
  background-color: #252e45;
  position: absolute;
  left: 41px;
  top: 22px;
}
</style>



// WEBPACK FOOTER //
// src/base/BindWx.vue